import axios from 'axios'
import { SessionContext } from 'contexts/session'
import { useContext } from 'react'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

type Params = {
  stationCode: string
  blockIndex: string
}

function useEnergySegmentsQuery(): UseQueryResult {
  const { stationCode, blockIndex } = useParams<Params>()
  const { session } = useContext<any>(SessionContext)

  return useQuery(
    ['energySegment', stationCode, blockIndex],
    async () => {
      const apiUrl = session.server
      const axiosOptions = {
        headers: {
          Accept: 'application/json',
          papitoken: session.token,
        },
      }

      const response = await axios.get(
        `${apiUrl}station/${stationCode}/block/${blockIndex}/energysegments`,
        axiosOptions,
      )
      return response.data
    },
    { refetchInterval: 5000 },
  )
}

export default useEnergySegmentsQuery
